import axios from 'axios'
import {
    RecordArchiveApiV1AdjutantAppRecordRecordIdArchivePostParams,
    RecordArchiveModel,
    RecordCreateModel,
    RecordDeleteApiV1AdjutantAppRecordRecordIdDeleteParams,
    RecordDeleteOutputDTO,
    RecordDetailApiV1AdjutantAppRecordRecordIdGetParams,
    RecordDTO,
    RecordListApiV1AdjutantAppRecordGetParams,
    RecordListOutputDTO,
    RecordUpdateApiV1AdjutantAppRecordRecordIdPatchParams,
    RecordUpdateModel,
    RMRModel,
} from '../swagger/dto'
import {
    BodyFoPresignPostApiV1UserFolderFileObjectPresignPostPost,
    ExternalUploadListOutputDTO,
} from '../swagger/dtoGateway'
import { deleteRequest, getRequest, patchRequest, postRequest } from './config'
import {
    EXTERNAL_GATEWAY_URL,
    PRESIGNED_GATEWAY_URL,
    RECORD_STAGE_URL,
    RECORD_URL,
} from './endpoints.constants'
import { FoPresignPostApiV1UserFolderFileObjectPresignPostPost200 } from './gen/fileGW'

export const getRecordList = async (params: RecordListApiV1AdjutantAppRecordGetParams) => {
    const response = await getRequest<RecordListOutputDTO>(RECORD_URL, params)
    return response.data
}

export const getRecordDetail = async (
    params: RecordDetailApiV1AdjutantAppRecordRecordIdGetParams,
) => {
    const response = await getRequest<RecordDTO>(`${RECORD_URL}/${params.recordId}`)

    return response.data
}

export const createRecord = async (data: RecordCreateModel) => {
    const response = await postRequest<RecordCreateModel, RecordDTO>(RECORD_URL, data)
    return response.data
}

export const patchRecord = async (
    params: RecordUpdateApiV1AdjutantAppRecordRecordIdPatchParams,
    payload: RecordUpdateModel,
) => {
    const response = await patchRequest<RecordDTO>(`${RECORD_URL}/${params.recordId}`, payload)
    return response.data
}

export const deleteRecord = async (
    params: RecordDeleteApiV1AdjutantAppRecordRecordIdDeleteParams,
) => {
    const response = await deleteRequest<RecordDeleteOutputDTO>(`${RECORD_URL}/${params.recordId}`)
    return response.data
}

export const archiveRecord = async (
    params: RecordArchiveApiV1AdjutantAppRecordRecordIdArchivePostParams,
    data: RecordArchiveModel,
) => {
    const response = await postRequest<RecordArchiveModel, RecordDTO>(
        `${RECORD_URL}/${params.recordId}/archive`,
        data,
    )
    return response.data
}

export const createPresignedUrl = async (
    data: BodyFoPresignPostApiV1UserFolderFileObjectPresignPostPost,
) => {
    const response = await postRequest<
        BodyFoPresignPostApiV1UserFolderFileObjectPresignPostPost,
        FoPresignPostApiV1UserFolderFileObjectPresignPostPost200
    >(PRESIGNED_GATEWAY_URL, data, false)
    return response.data
}

export const uploadFile = async ({ url, formData }) => {
    const response = await axios({
        method: 'POST',
        url,
        data: formData,
    })
    return response.data
}

export const getExternalFiles = async (params) => {
    const response = await getRequest<ExternalUploadListOutputDTO>(
        EXTERNAL_GATEWAY_URL,
        params,
        false,
    )
    return response.data
}

export const createStateByRecord = async (data: RMRModel) => {
    const response = await postRequest<RMRModel, RecordDTO>(RECORD_STAGE_URL, data)
    return response.data
}
